import ConfigSidebar from "./ConfigSidebar";
import { EndpointType } from "../../constants/Endpoints";
import ConfigOpenButton from "../../molecules/config/ConfigOpenButton";
import { cn } from "../../utils/style";

interface ConfigPanelProps {
  showConfig: boolean;
  isConfigSidebarOpen: boolean;
  setIsConfigSidebarOpen: (isConfigSidebarOpen: boolean) => void;
  endpointType: EndpointType;
  className?: string;
}

export function ConfigPanel({
  showConfig,
  isConfigSidebarOpen,
  setIsConfigSidebarOpen,
  endpointType,
  className,
}: ConfigPanelProps) {
  if (!showConfig) return null;

  return (
    <div className={className}>
      <div
        className={cn(
          "absolute m-2.5 flex gap-2",
          "transition-all duration-300 ease-in-out",
          isConfigSidebarOpen
            ? "right-[calc(theme(width.config-sidebar)_-_theme(space.12))]"
            : "right-0",
        )}
      >
        <ConfigOpenButton
          onClick={() => setIsConfigSidebarOpen(!isConfigSidebarOpen)}
          className={isConfigSidebarOpen ? "!opacity-0" : "opacity-100"}
        />
      </div>

      <ConfigSidebar
        isOpen={isConfigSidebarOpen}
        onClose={() => setIsConfigSidebarOpen(false)}
        className={isConfigSidebarOpen ? "desktop:z-5 mobile:z-20" : "-z-10"}
        endpointType={endpointType}
      />
    </div>
  );
}
